import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const PersonIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="5" r="2.5" stroke="#CCCCCC" strokeWidth="1.5" fill="none" />
      <path
        d="M3 14C3 11.24 5.24 9 8 9C10.76 9 13 11.24 13 14"
        stroke="#CCCCCC"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
